export default {
    data() {
        return {
            srcs: ['/img/icons/pressed/garniture-view.svg'],
            pics: []
        }
    },
    mounted() {
        this.preloadImages()
    },
    methods: {
        preloadImages() {
            for (let i = 0; i < this.srcs.length; i++) {
                this.pics[i] = new Image()
                this.pics[i].src = this.srcs[i]
            }
        }
    }
}
